import { ChangeUserData } from 'modules/users/components'
import { User } from 'framework/users'
import { useNotification, useUserSession } from 'hooks'
import type { FC } from 'react'
import { UserService } from 'modules/users/services'
import { useState, useEffect } from 'react'

import type { UserChangeDataProps } from '.'

const UserChangePassword: FC<UserChangeDataProps> = () => {
  const { notify } = useNotification()
  const { setUser, user } = useUserSession()

  const [userData, setUserData] = useState({} as any)

  useEffect(() => {
    const userService = new UserService(user as unknown as User)
    userService.getCustomerData().then(({ data: { customer } }: { data: { customer: any } }) =>
      setUserData({
        ...user,
        phone: customer.telefone,
        birthday: customer.data_nascimento ? customer.data_nascimento.split('-').reverse().join('/') : '',
        company_name: customer?.nome_responsavel,
        insEstadual: customer?.ins_estadual,
        isExemptState: customer?.isento_ins_estadual,
        fantasyName: customer?.nome_fantasia,
        isPerson: customer.tipo_pessoa === 'PF',
      }),
    )
  }, [])

  async function onSubmit(
    email: string,
    name: string,
    phone: string,
    birthday: string,
    fantasy_name: string,
    name_company: string,
    ins_estadual: string,
  ) {
    try {
      const userService = new UserService()
      if (user && user.id) {
        userService.setUser(user as unknown as User)
      }

      await userService.updateUserProfile(email, phone, name, birthday, fantasy_name, name_company, ins_estadual)

      setUser({
        ...user,
        name,
      })

      notify({
        title: 'Sucesso',
        description: 'Seus dados foram alterados!',
        type: 'success',
      })
    } catch (e) {
      notify({
        title: 'Atenção',
        description: e?.response?.data?.message || 'Houve um erro ao atualizar seus dados',
        type: 'danger',
      })
    }
  }

  return (
    <>
      <ChangeUserData onSubmit={onSubmit} data={userData} />
    </>
  )
}

export default UserChangePassword
